<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=false><p slot="title">结算记录</p></sub-ibox-title>
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'Finance',
		components: {
		},
		data() {
			return {
				
			}
		},
		methods: {
		}
	}
</script>



// WEBPACK FOOTER //
// Index.vue?6227f24a